import { Fragment, useEffect, useState } from "react";
import { useAsync } from "../../../utils/hooks/useAsync";
import { AdminService } from "../utils";
import "./ListVariations.scss";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Collapsible from "react-collapsible";
import Label from "../../Label";
import { normalizeWastage } from "../../../utils/wastage";
import { groupVariantRows } from "../variantOptions";
import WorkmanshipSelect from "../WorkmanshipSelect";

type Props = {
  Variations: Variation[];
  manufacturingCost: ManufacturingCost[];
  isSolid: boolean;
  department: string;
  material: string;
};

const ListVariations: React.FC<Props> = ({
  Variations,
  manufacturingCost,
  isSolid,
  department,
  material,
}) => {
  const wastageLabel = (value?: Wastage) => {
    if (value === "NO_WASTAGE") {
      return "Sin merma";
    }
    return value || "825";
  };
  const { run } = useAsync();
  const [modified, setModified] = useState<boolean>(false);
  const [modifiedVariations, setModifiedVariations] =
    useState<Variation[]>(Variations);
  const groupedVariations = groupVariantRows(modifiedVariations, material);
  const collapsible = (gauge: string) => (
    <div className="trigger">
      <p>{gauge}</p>
    </div>
  );
  useEffect(() => {
    setModifiedVariations(Variations);
  }, [Variations]);

  const handleChange = (e: any, id?: string) => {
    setModified(true);
    setModifiedVariations(
      modifiedVariations.map((el) =>
        el._id == id
          ? { ...el, [e.currentTarget.name]: e.currentTarget.value }
          : el,
      ),
    );
  };

  const handleDelete = (data: Variation) => {
    run(
      AdminService.deleteVariation(data).then((r: any) => {
        toast.success("Variación eliminada");
        setModifiedVariations(
          modifiedVariations.filter((el) => el._id != data._id),
        );
      }),
    );
  };

  const SaveVariations = () => {
    let deltas: Variation[] = [];
    for (let index = 0; index < modifiedVariations.length; index++) {
      JSON.stringify(modifiedVariations[index]) !=
        JSON.stringify(Variations.find((original) => original._id === modifiedVariations[index]._id)) &&
        deltas.push(modifiedVariations[index]);
    }
    const normalizedDeltas = deltas.map((vari) => ({
      ...vari,
      wastage: normalizeWastage(vari.wastage, material),
    }));
    run(
      AdminService.updateVariations(normalizedDeltas).then((data) => {
        setModified(false);
        data.data.nModified > 0 && toast.success("Modificaciones guardadas");
      }),
    );
  };
  return (
    <div className="listVariationsContainer">
      <ToastContainer autoClose={1500} position={"bottom-left"} />

      {groupedVariations &&
        groupedVariations.map((gvar) => {
          return (
            <Fragment key={gvar.gauge}>
              <Collapsible
                className="resultsAddVariationHeader"
                triggerOpenedClassName="resultsAddVariationHeader"
                triggerWhenOpen={collapsible("∧  " + gvar.gauge)}
                trigger={collapsible("∨  " + gvar.gauge)}
              >
                <div className="resultsAddVariationItems">
                  {(department == "chain" || department == "brazalete") &&
                  isSolid ? (
                    <Label
                      tag="h3"
                      style={{
                        fontFamily: "Mont-Light",
                        fontSize: "12px",
                        textAlign: "start",
                        width: "20%",
                      }}
                    >
                      LARGO
                    </Label>
                  ) : (
                    <Label
                      tag="h3"
                      style={{
                        fontFamily: "Mont-Light",
                        fontSize: "12px",
                        textAlign: "start",
                        width: "20%",
                      }}
                    >
                      MEDIDAS
                    </Label>
                  )}
                  <Label
                    tag="h3"
                    style={{
                      fontFamily: "Mont-Light",
                      fontSize: "12px",
                      textAlign: "start",
                      width: "20%",
                      marginRight: " 3px",
                      marginLeft: "3px",
                      paddingRight: "2px",
                    }}
                  >
                    PESO
                  </Label>
                  <Label
                    tag="h3"
                    style={{
                      fontFamily: "Mont-Light",
                      fontSize: "12px",
                      textAlign: "start",
                      width: "20%",
                      marginRight: "3px",
                      marginLeft: "3px",
                      paddingRight: "2px",
                    }}
                  >
                    HECHURA
                  </Label>
                  <Label
                    tag="h3"
                    style={{
                      fontFamily: "Mont-Light",
                      fontSize: "12px",
                      textAlign: "start",
                      width: "20%",
                    }}
                  >
                    COLOR
                  </Label>
                  <Label
                    tag="h3"
                    style={{
                      fontFamily: "Mont-Light",
                      fontSize: "12px",
                      textAlign: "start",
                      width: "20%",
                      marginRight: "3px",
                      marginLeft: "3px",
                      paddingRight: "2px",
                    }}
                  >
                    MERMA
                  </Label>

                  <p
                    style={{
                      textAlign: "end",
                      textDecoration: "underline",
                      marginRight: 10,
                      width: "20%",
                    }}
                  ></p>
                </div>
                {gvar.variations.map((vari) => {
                  return (
                    <div
                      className="resultsAddVariationItems"
                      key={vari._id}
                    >
                      <p>
                        {vari.length}{" "}
                        {(department == "chain" || department == "brazalete") &&
                        isSolid
                          ? "cm"
                          : "mm"}
                      </p>
                      <input
                        className="weight"
                        type="text"
                        name="weight"
                        onChange={(e) => handleChange(e, vari._id)}
                        defaultValue={vari.weight + " gr"}
                      ></input>
                      <WorkmanshipSelect
                        label={`Hechura: Hilo ${vari.gauge || "sin dato"}, Largo ${vari.length || "sin dato"}, Color ${vari.color || "sin dato"}`}
                        costs={manufacturingCost}
                        value={vari.manufacturingCostId}
                        onChange={(id) => handleChange({ currentTarget: { name: "manufacturingCostId", value: id } }, vari._id)}
                      />

                      <p>
                        {(vari.color || "").charAt(0).toUpperCase() +
                          (vari.color || "").slice(1)}
                      </p>
                      <p>{wastageLabel(vari.wastage)}</p>
                      <p
                        onClick={() => handleDelete(vari)}
                        style={{
                          textAlign: "end",
                          textDecoration: "underline",
                          marginRight: 10,
                        }}
                        className="deleteButton"
                      >
                        Borrar
                      </p>
                    </div>
                  );
                })}
              </Collapsible>
            </Fragment>
          );
        })}
      {modified && (
        <div className="saveVariationButtonContainer">
          <button
            type="button"
            className="save_variations"
            onClick={SaveVariations}
          >
            Grabar Modificaciones
          </button>
        </div>
      )}
    </div>
  );
};

export default ListVariations;
